import './all-res.css';

export function DesignSubPage() {

    return (
        <div className="container-fluid m-4">
            <h4 className="gradient-text"> Design </h4>
            <p className='para'>I prioritize visually appealing design in all of my projects to create a unique and memorable user experience.</p>
        </div>
    )
}